<template>
  <div class="carousel_wrap">
    <el-carousel height="22vw" loop arrow="never" class="hidden-xs-only">
      <el-carousel-item v-for="(item, index) in imgList" :key="index">
        <img :src="item.src" alt="" class="img_item" @click="gotoDemo()" v-if="index === 4" style="cursor: pointer"/>
        <img :src="item.src" alt="" class="img_item" v-else/>
        <div class="tips_font2">
          <div class="title">{{ item.line1 }}</div>
          <div class="title">{{ item.line2 }}</div>
          <div class="desc">{{ item.line11 }}</div>
          <div class="desc">{{ item.line12|| '' }}</div>
          <div class="desc"><el-button type="primary" class="detail_btn_sy" @click="gotoDemo()">立即咨询</el-button></div>
        </div>
<!--        <div class="tips_font" v-else>-->
<!--          <div class="title">{{ item.line1 }}</div>-->
<!--          <div class="desc">{{ item.line2 }}</div>-->
<!--        </div>-->
      </el-carousel-item>
    </el-carousel>
    <el-carousel height="200px" loop arrow="never" class="hidden-sm-and-up">
      <el-carousel-item v-for="(item, index) in imgMobileList" :key="index">
        <img :src="item.src" alt="" class="img_item" @click="gotoDemo()"  style="cursor: pointer"/>
<!--        <img :src="item.src" alt="" class="img_item" v-else/>-->
        <div class="tips_font">
          <div class="title">{{ item.line1 }}</div>
          <div class="title">{{ item.line2 }}</div>
          <div class="desc">{{ item.line11 }}</div>
          <div class="desc">{{ item.line12 }}</div>
          <div class="desc">{{ item.line13 }}</div>
          <div class="desc">{{ item.line14 }}</div>
          <div class="desc"><el-button type="primary" class="detail_btn_sy" @click="gotoDemo()">立即咨询</el-button></div>
        </div>
<!--        <div class="tips_font top50" v-else-if="index === 2">-->
<!--          <div class="title">{{ item.line1 }}</div>-->
<!--          <div class="title1">{{ item.line2 }}</div>-->
<!--          <div class="desc">{{ item.line11 }}</div>-->
<!--          <div class="desc">{{ item.line22 }}</div>-->
<!--        </div>-->
<!--        <div class="tips_font" v-else>-->
<!--          <div class="title">{{ item.line1 }}</div>-->
<!--          <div class="title">{{ item.line11 }}</div>-->
<!--          <div class="desc">{{ item.line2 }}</div>-->
<!--          <div class="desc">{{ item.line22 }}</div>-->
<!--        </div>-->
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgList: [
        {
          src: require('@/assets/img/synology-new/banner/01.jpg'),
          line1: '群晖Synology企业私有云盘',
          line2: 'NAS网络存储服务器',
        },
        {
          src: require('@/assets/img/synology-new/banner/04.jpg'),
          line1: 'Synology 虚拟化',
          line11: 'Synology 的虚拟化解决方案支持部署虚拟机，或作为其他虚拟机环境的存储节点，',
          line12: '充分利用 Synology NAS 的强大功能，并确保数据安全性和可用性',
        },
        {
          src: require('@/assets/img/synology-new/banner/02.jpg'),
          line1: '企业数据共享与文件备份方案',
          line11: '群晖 NAS 支持跨系统、平台、地域同步文件，提升工作效率及文件安全',
        },
        {
          src: require('@/assets/img/synology-new/banner/03.jpg'),
          line1: '企业备份一体机',
          line11: '使用群晖备份一体机，备份物理服务器、虚拟机，以及 SaaS 服务，保护企业数据安全',
        }

      ],
       imgMobileList: [

        {
          src: require('@/assets/img/synology-new/sy-mobile/banner01.jpg'),
          line1: '群晖Synology企业私有云盘',
          line2: 'NAS网络存储服务器',
        },
        {
          src: require('@/assets/img/synology-new/sy-mobile/banner04.jpg'),
          line1: 'Synology 虚拟化',
          line11: 'Synology 的虚拟化解决方案支持部署虚拟机，或作为',
          line12: '其他虚拟机环境的存储节点，充分利用 Synology NAS',
          line13: ' 的强大功能，并确保数据安全性和可用性',
        },
        {
          src: require('@/assets/img/synology-new/sy-mobile/banner02.jpg'),
          line1: '企业数据共享与文件备份方案',
          line11: '群晖 NAS 支持跨系统、平台、地域同步文件，',
          line12: '提升工作效率及文件安全',
        },{
          src: require('@/assets/img/synology-new/sy-mobile/banner03.jpg'),
           line1: '企业备份一体机',
           line11: '使用群晖备份一体机，备份物理服务器、虚拟机，',
           line12: '以及 SaaS 服务，保护企业数据安全，',
        }

      ],
    }
  },
  methods:{
    gotoDemo(){
      this.$emit('to-zixun');
    }

  }
}
</script>

<style lang="scss">
.carousel_wrap {
  //position: relative;
  margin-top: 70px;
  .el-carousel__item {
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .top50{
    top: 46PX !important; ;
  }
  .tips_font {
    position: absolute;
    width: 70%;
    margin: auto;
    top: 10px;
    height: 100%;
    left: 15%;
    z-index: 5;
    color: #fff;
    font-size: 25px;
    text-align: center;

    @media screen and (max-width: 768px) {
      display: flex;
      flex-direction: column;
      align-content: center;
      align-items: center;
      justify-content: center;
      width: 100%;
      left: 0;
    }
    .title {
      font-size: 36px;
      font-weight: bold;
      margin-bottom: 26px;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
        line-height: 1.5rem;
      }
    }
    .desc {
      font-size: 18px;
      margin-top: 10px;
      margin-bottom: 10px;
      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        margin-bottom: 0.2rem;
      }
    }
    @media screen and (max-width: 768px) {
      font-size: 0.5rem;
    }
  }
  .detail_btn_sy{
    background-color: #0052D9 !important;
    width: 150px;
    padding: 12px;
    margin-top: 15px;
    border-color:#0052D9 ;
    @media screen and (max-width: 768px) {
      font-size: 0.7rem;
      width: 100PX;
      padding: 5PX;
      margin-top: 10PX;
      line-height: 1rem;
      border-radius: 3PX;
    }
  }
  .tips_font2 {
    position: absolute;
    top: 120px;
    left: 15%;
    z-index: 5;
    color: #fff;
    font-size: 25px;
    @media screen and (max-width: 768px) {
      top: 50PX;
      width: 100%;
      left: 20PX;
    }
    .title {
      font-size: 36px;
      font-weight: bold;
      margin-bottom: 10px;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
        line-height: 1.5rem;
      }
    }
    .title1 {
      font-size: 36px;
      font-weight: bold;
      margin-bottom: 26px;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
        line-height: 1.5rem;
        margin-bottom: 10PX;
      }
    }
    .desc {
      font-size: 20px;
      margin-top: 10px;
      margin-bottom: 10px;
      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        margin-bottom: 0.2rem;
      }
    }
    @media screen and (max-width: 768px) {
      font-size: 0.5rem;
    }
  }
}
</style>